import Link from 'next/link';

import { TabItem } from '../../../types/tabs';

/* eslint-disable-next-line */
type BreadcrumbsProps = {
  color?: string;
  position?: string;
  subTab: TabItem;
  tab: TabItem;
};

export function Breadcrumbs(props: BreadcrumbsProps) {
  const {
    color = 'text-white md:text-formGray',
    position,
    subTab,
    tab
  } = props;

  return (
    <div
      className={`${color} text-caption font-BebasNeue space-x-1 absolute z-20 ${position} hidden sm:flex tracking-wide`}
    >
      <Link href="/">
        <a className="after:content-['/'] after:pl-1 hover:text-primaryBlue uppercase">
          SUB-ZERO &amp; WOLF
        </a>
      </Link>
      <Link href={tab.route}>
        <a className="after:content-['/'] after:pl-1 hover:text-primaryBlue uppercase">
          {tab.tabLabel}
        </a>
      </Link>
      <Link href={subTab.route}>
        <a className="hover:text-primaryBlue uppercase">{subTab.tabLabel}</a>
      </Link>
    </div>
  );
}

export default Breadcrumbs;
